<template>
    <div>
        <p-card>
            <h4>Purchase Orders</h4>
            <p-table
                :items="productInfo.purchaseOrders"
                :fields="purchaseOrderFields"
                :enable-row-selection="false"
                sort-by="poNumber"
            >
                <template v-slot:cell(poNumber)="{ item }">
                    <router-link :to="`/purchaseorders/${item.purchaseOrderId}`">{{ item.poNumber }}</router-link>
                </template>
            </p-table>
        </p-card>
        <p-card class="mt-3">
            <h4>Invoices</h4>
            <p-table
                :items="productInfo.invoices"
                :fields="invoiceFields"
                :enable-row-selection="false"
                sort-by="invoiceNumber"
            >
                <template v-slot:cell(invoiceNumber)="{ item }">
                    <router-link :to="`/invoices/${item.invoiceId}`">{{ item.invoiceNumber }}</router-link>
                </template>
            </p-table>
        </p-card>
        <p-card class="mt-3">
            <h4>Returns</h4>
            <p-table
                :items="productInfo.returns"
                :fields="returnFields"
                :enable-row-selection="false"
                sort-by="returnNumber"
            >
                <template v-slot:cell(returnNumber)="{ item }">
                    <router-link :to="`/creditrequests/${item.creditRequestId}`">{{ item.returnNumber }}</router-link>
                </template>
            </p-table>
        </p-card>
        <p-card class="mt-3">
            <h4>Course Requests</h4>
            <p-table
                :items="productInfo.courseRequests"
                :fields="courseRequestFields"
                :enable-row-selection="false"
                sort-by="termName"
            >
                <template v-slot:cell(termName)="{ item }">
                    <router-link :to="`/courserequests/${item.courseRequestId}`">{{ item.termName }}</router-link>
                </template>
            </p-table>
        </p-card>
        <p-card class="mt-3">
            <h4>Rentals</h4>
            <p-table
                :items="productInfo.rentals"
                :fields="rentalFields"
                :enable-row-selection="false"
                sort-by="termName"
            />
        </p-card>
    </div>
</template>
<script>
import { dateFormatter, currencyFormatter } from '@/components/Common/Formatters.js';
export default {
    props: {
        productInfo: Object
    },
    data() {
        return {
            purchaseOrderFields: [
                {
                    key: 'poNumber',
                    label: 'PO Number',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'poDate',
                    label: 'PO Date',
                    formatter: value => (value ? dateFormatter(value) : '-'),
                    sortable: true
                },
                {
                    key: 'supplierName',
                    label: 'Supplier',
                    sortable: true
                },
                {
                    key: 'total',
                    label: 'Total',
                    formatter: value => currencyFormatter(value, '-'),
                    sortable: true
                },
                {
                    key: 'referenceNumber',
                    label: 'Reference #',
                    sortable: true
                },
                {
                    key: 'externalPoNumber',
                    label: 'External PO #',
                    sortable: true
                },
                {
                    key: 'lastModifiedDate',
                    label: 'Last Modified',
                    formatter: value => (value ? dateFormatter(value) : '-'),
                    sortable: true
                }
            ],
            invoiceFields: [
                {
                    key: 'invoiceNumber',
                    label: 'Invoice Number',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'invoiceDate',
                    label: 'Invoice Date',
                    formatter: value => (value ? dateFormatter(value) : '-'),
                    sortable: true
                },
                {
                    key: 'dueDate',
                    label: 'Due Date',
                    formatter: value => (value ? dateFormatter(value) : '-'),
                    sortable: true
                },
                {
                    key: 'supplierName',
                    label: 'Supplier',
                    sortable: true
                }
            ],
            returnFields: [
                {
                    key: 'returnNumber',
                    label: 'Return Number',
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    formatter: value => (value === 2 ? 'Discrepancy' : 'Return'),
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'createDate',
                    label: 'Create Date',
                    formatter: value => (value ? dateFormatter(value) : '-'),
                    sortable: true
                },
                {
                    key: 'rmaNumber',
                    label: 'RMA Number',
                    sortable: true
                },
                {
                    key: 'creditDue',
                    label: 'Credit Due',
                    formatter: value => currencyFormatter(value, '-'),
                    sortable: true
                },
                {
                    key: 'supplierName',
                    label: 'Supplier',
                    sortable: true
                }
            ],
            courseRequestFields: [
                {
                    key: 'termName',
                    label: 'Term',
                    sortable: true
                },
                {
                    key: 'adoptionStatus',
                    label: 'Adoption Status',
                    sortable: true
                },
                {
                    key: 'campusName',
                    label: 'Campus',
                    sortable: true
                },
                {
                    key: 'departmentName',
                    label: 'Department',
                    sortable: true
                },
                {
                    key: 'departmentCode',
                    label: 'Department Code',
                    sortable: true
                },
                {
                    key: 'courseNumber',
                    label: 'Course Number',
                    sortable: true
                },
                {
                    key: 'courseLevel',
                    label: 'Course Level',
                    sortable: true
                },
                {
                    key: 'sectionName',
                    label: 'Section',
                    sortable: true
                },
                {
                    key: 'sectionId',
                    label: 'Section ID',
                    sortable: true
                },
                {
                    key: 'instructorName',
                    label: 'Instructor',
                    sortable: true
                }
            ],
            rentalFields: [
                {
                    key: 'termName',
                    label: 'Term',
                    sortable: true
                }
            ]
        };
    }
};
</script>
